module.exports = __webpack_public_path__ + "img/orcanetwork.04c0c070.png";